import React, { useState, useEffect } from 'react';
import Header from '../JobPage/Header';
import Footer from '../JobPage/Footer';
import JobForm from '../JobForm/JobForm';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import useCompanies from '../Hooks/useCompanies';
import useJobsByCompany from '../Hooks/useJobsByCompany';
import JobList from './JobList';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';
import { Button } from '@/Components/ui/button';
import { Badge } from '@/Components/ui/badge';
import { cn } from '@/lib/utils';

const ExploreComponent = () => {
  const navigate = useNavigate();
  const [isJobFormOpen, setIsJobFormOpen] = useState(false);
  const [showAllRecruitment, setShowAllRecruitment] = useState(false);

  const handleApplyClick = () => {
    setIsJobFormOpen(true);
  };

  const handleCloseJobForm = () => {
    setIsJobFormOpen(false);
  };

  const handleCompanyNameClick = (companyId) => {
    navigate(`/companyoverview/${companyId}`);
  };

  const { compnayId } = useParams();
  const companies = useCompanies();
  const [company, setCompany] = useState(null);
  const jobs = useJobsByCompany(compnayId);

  useEffect(() => {
    if (companies && companies.length > 0) {
      const selectedCompany = companies.find(
        (company) => company.id === parseInt(compnayId)
      );
      setCompany(selectedCompany);
    }
  }, [companies, compnayId]);

  if (!company) {
    return <div>Loading...</div>;
  }

  const recruitmentPositions = [
    'Digital Marketing Manager',
    'UI/UX Designer',
    'Artificial Intelligence Engineer',
    'Full Stack Developer',
    'Data Analyst',
    'Cybersecurity Analyst',
    'Cloud Engineer',
    'DevOps Engineer',
    'Product Manager',
    'Software Architect',
    'Machine Learning Engineer',
    'Technical Writer',
    'Backend Developer',
    'Frontend Developer',
    'Mobile App Developer',
    'QA Engineer',
    'Business Analyst',
    'Data Scientist',
    'Network Engineer',
    'System Administrator',
    'IT Support Specialist',
    'Technical Support Specialist',
    'IT Project Manager',
    'IT Consultant',
    'IT Auditor',
    'IT Sales Professional',
  ];

  const visiblePositions = showAllRecruitment ? recruitmentPositions : recruitmentPositions.slice(0, 5);

  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col">
      <div className="sticky top-0 z-[1000] w-full">
        <Header />
      </div>
      <Container size="default" className="flex-1 mt-[135px] mb-[150px]">
        <Stack spacing="xl">
          <Stack spacing="lg">
            <Inline justify="between" align="center" className="mb-4">
              <Heading 
                level="h1" 
                className="text-[35px] text-primary cursor-pointer whitespace-nowrap"
                onClick={() => handleCompanyNameClick(company.id)}
              >
                {company.companyName}
              </Heading>
              <img
                className="w-[50px] h-[50px]"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/dcde782ed1d60488ee15de406073d30ea9cd0132b3c36e336aa6323594295232?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                alt="Company Icon"
              />
            </Inline>
            
            <Inline spacing="md" wrap className="mt-2">
              <Inline spacing="sm" align="center">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/51bab7189fce9025d705ab2b3980269e2d036f67f15aa7fd126ade52dc64b130?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                  alt="Location"
                  className="w-6 h-6"
                />
                <Text size="lg">{company.mapLocation}</Text>
              </Inline>
              <Inline spacing="sm" align="center">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/69893f45568116d2499e75d29a470e87c6a98f59947d43676bbd3e7099a4bd1f?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                  alt="Privacy"
                  className="w-6 h-6"
                />
                <Text size="lg">{company.organizationType}</Text>
              </Inline>
              <Text size="lg">{company.industryType}</Text>
            </Inline>

            <Stack spacing="md" className="mt-[70px]">
              <Heading level="h2" className="text-[35px] text-primary">
                About Company
              </Heading>
              <Text size="lg" className="mt-5 leading-relaxed">
                {company.aboutUs}
              </Text>
            </Stack>

            <Stack spacing="md" className="mt-5">
              <Heading level="h2" className="text-[25px] text-foreground">
                About Recruitment
              </Heading>
              <Inline spacing="md" wrap className="mt-5">
                {visiblePositions.map((position, index) => (
                  <Badge 
                    key={index} 
                    variant="outline" 
                    className="px-3 py-2 text-sm cursor-pointer hover:bg-accent transition-all hover:-translate-y-0.5"
                  >
                    {position}
                  </Badge>
                ))}
              </Inline>
              {!showAllRecruitment && (
                <Button 
                  variant="default" 
                  className="mt-6 w-[15%]"
                  onClick={() => setShowAllRecruitment(true)}
                >
                  View More
                </Button>
              )}
            </Stack>
          </Stack>

          <Stack spacing="lg" className="mt-[70px]">
            <Heading level="h2" className="text-[35px] text-primary">
              Openings
            </Heading>
            <div className="mt-4">
              <JobList companyId={compnayId} />
            </div>
          </Stack>
        </Stack>
      </Container>
      <Footer />
    </div>
  );
};

export default ExploreComponent;
